import styles from './ProductSwiper.module.less';

let imagesReadyTimer;
let rewriteGrids;

function clearTimers() {
  if (imagesReadyTimer) {
    clearTimeout(imagesReadyTimer);
  }
  if (rewriteGrids) {
    clearInterval(rewriteGrids);
  }
}

function onInit() {
  this.isEnd = true;
}

export function recalcGrids() {
  const measureProperty =
    this.originalParams.direction === 'vertical'
      ? 'clientHeight'
      : 'clientWidth';

  clearTimers();
  imagesReadyTimer = setTimeout(() => {
    const slideWindowHeight = this.el[measureProperty];
    const slides = Array.from(
      this.el.getElementsByClassName(styles.swiperSlide)
    );

    const slidesSizesGrid = slides.map(slide => slide[measureProperty]);
    let maxTranslate = -slideWindowHeight;
    let pos = slidesSizesGrid.length;
    while (pos--) {
      maxTranslate += slidesSizesGrid[pos];
    }

    let slidesGrid = slidesSizesGrid.reduce(
      function (grid, slide) {
        grid.push((grid.length && grid[grid.length - 1] + slide) || 0);
        return grid;
      },
      [0]
    );
    // first make it snap slides to the top
    let snapGrid = slidesGrid.slice(0);
    /* remove any points that are
      - less than 0
      - would make the swiper translate more than necessary
      - duplicates
      */
    snapGrid = snapGrid.filter(function (pos, index, grid) {
      return pos >= 0 && pos <= maxTranslate && grid.indexOf(pos) === index;
    });

    snapGrid.sort(function (a, b) {
      return a - b;
    });

    if (snapGrid.length === 0) {
      // no snap points means that we don't have a full page of slides,
      // so give it somewhere to snap so it doesn't scroll all over the place
      snapGrid.push(0);
      slidesGrid = [slidesGrid[0]];
    } else if (snapGrid.length === 1) {
      // if only snapping to front, and maxtranslate doesnt completely hide
      // item 0, we need to add this to allow moving to the end
      snapGrid.push(maxTranslate);
    } else if (snapGrid.length > 1) {
      snapGrid.pop();
      snapGrid.push(maxTranslate);
    }

    const updateGridValues = () => {
      this.snapGrid = snapGrid;
      this.slidesGrid = slidesGrid;
      this.slidesSizesGrid = slidesSizesGrid;
      this.isEnd = snapGrid.length === 1;
      this.navigation.update();
    };

    updateGridValues();
    // reset to top position to dodge arrow buttons acting weird post flip
    this.setTranslate(0);

    let rewrites = 0;
    rewriteGrids = setInterval(() => {
      rewrites++;
      updateGridValues();
      if (rewrites > 30) {
        clearInterval(rewriteGrids);
      }
    }, 50);
  }, 50);
}

const settings = isVertical => ({
  direction: isVertical ? 'vertical' : 'horizontal',
  on: {
    beforeDestroy: clearTimers,
    imagesReady: recalcGrids,
    resize: recalcGrids,
    init: onInit,
  },
  initialSlide: 0,
  loop: false,
  mousewheel: {
    mousewheelReleaseOnEdges: true,
    sensitivity: 3,
  },
  keyboard: {
    enabled: false,
  },
  spaceBetween: 0,
  slideToClickedSlide: false,
  simulateTouch: true,
  paginationClickable: true,
  freeMode: true,
  freeModeMinimumVelocity: 0.1,
  freeModeMomentumBounce: false,
  freeModeMomentumRatio: 0.35,
  freeModeSticky: true,
  grabCursor: false,
  roundLengths: true,

  preventClicks: false,
  preventClicksPropagation: false,
  centeredSlides: false,
  slidesOffsetAfter: 0,

  slideClass: styles.swiperSlide,
  wrapperClass: styles.slidesWrapper,
  navigation: {
    nextEl: '.' + styles.swiperButtonNext,
    prevEl: '.' + styles.swiperButtonPrev,
    disabledClass: styles.disabled,
  },
});

export default settings;
